import { Event } from './Event';
var onNotificationEvent = new Event();
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
export var Category;
(function (Category) {
    Category[Category["Core"] = 0] = "Core";
    Category[Category["Sink"] = 1] = "Sink";
    Category[Category["Transport"] = 2] = "Transport";
})(Category || (Category = {}));
/**
 * Returns a list of notification event listeners. You can add an event listener:
 *    onNotification().addListener(event =\> \{
 *      console.log(event!.message + ' ' + event!.level); \});
 *
 * DO NOT trigger telemetry events on these notifications, as doing so may
 * create an infinite loop of telemetry events.
 */
export function onNotification() {
    return onNotificationEvent;
}
/**
 * Internal function: log a notification
 * @param level - The level of notification to log
 * @param category - The category of the notification
 * @param message - A function that returns a message to log
 */
export function logNotification(level, category, message) {
    onNotificationEvent.fireEvent({ level: level, category: category, message: message });
}
/**
 * Internal function: log an error
 * @param category - The category of the notification
 * @param message - A message that will preceed the message from error object
 * @param error - An error object, from which an error message might be obtained
 */
export function logError(category, message, error) {
    logNotification(LogLevel.Error, category, function () {
        var errorMessage = error instanceof Error ? error.message : '';
        return message + ": " + errorMessage;
    });
}
//# sourceMappingURL=OTelNotifications.js.map